// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"03801628cae65d6b","5285":"be66c720b524ba48"}[chunkId] + ".css";
};